var getDisplayName = function (WrappedComponent) { return WrappedComponent.displayName || WrappedComponent.name || 'Component'; };
export default getDisplayName;
//# sourceMappingURL=getDisplayName.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/react/getDisplayName.js
// module id = 12
// module chunks = 1